import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, IconButton, Box, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import AccountCircle from '@mui/icons-material/AccountCircle';
import logo from '../assets/escobar_logo.jpg';

const Header = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const socialIcons = [
        { icon: <WhatsAppIcon />, url: 'https://wa.me/+918169699090', color: '#25D366' },
        { icon: <InstagramIcon />, url: 'https://www.instagram.com/rr.onlinegroup/', color: '#E4405F' },
        { icon: <TelegramIcon />, url: 'https://t.me/+919542877000', color: '#0088cc' },
    ];

    return (
        <AppBar
            position="fixed"
            sx={{
                background: scrolled ? 'rgba(0, 0, 0, 0.95)' : 'transparent',
                boxShadow: scrolled ? '0 4px 30px rgba(0,0,0,0.1)' : 'none',
                backdropFilter: scrolled ? 'blur(10px)' : 'none',
                borderBottom: scrolled ? `1px solid ${theme.palette.primary.main}` : 'none',
                transition: 'all 0.3s ease-in-out',
                height: scrolled ? '80px' : '120px',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="xl">
                <Toolbar sx={{ justifyContent: 'space-between', minHeight: '100% !important' }}>
                    {/* Logo Section */}
                    <Box
                        component="img"
                        src={logo}
                        alt="RR Group Logo"
                        sx={{
                            height: scrolled ? '90px' : (isMobile ? '120px' : '160px'),
                            transition: 'all 0.3s ease-in-out',
                            cursor: 'pointer',
                            // filter: 'drop-shadow(0 0 10px rgba(139, 0, 0, 0.5))', // Removed filter as jpg might have bg
                            borderRadius: '10px' // Add slight radius if it's a square block
                        }}
                    />

                    {/* Social Icons Section */}
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {socialIcons.map((item, index) => (
                            <IconButton
                                key={index}
                                size={isMobile ? 'small' : 'medium'}
                                onClick={() => window.open(item.url, '_blank')}
                                sx={{
                                    color: theme.palette.text.primary,
                                    bgcolor: 'rgba(139, 0, 0, 0.2)', // Semi-transparent red
                                    border: `1px solid ${theme.palette.primary.main}`,
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                        bgcolor: item.color,
                                        color: '#fff',
                                        transform: 'translateY(-2px)',
                                        boxShadow: `0 0 15px ${item.color}`,
                                        borderColor: item.color,
                                    }
                                }}
                            >
                                {item.icon}
                            </IconButton>
                        ))}

                        <IconButton
                            size={isMobile ? 'small' : 'medium'}
                            sx={{
                                color: theme.palette.secondary.main, // Gold
                                bgcolor: 'rgba(255, 215, 0, 0.1)',
                                border: `1px solid ${theme.palette.secondary.main}`,
                                marginLeft: 1,
                                '&:hover': {
                                    bgcolor: theme.palette.secondary.main,
                                    color: '#000',
                                    boxShadow: `0 0 15px ${theme.palette.secondary.main}`,
                                }
                            }}
                        >
                            <AccountCircle fontSize="large" />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;
